import { getUserAgentDetails } from '@hh.ru/browser-api-utils';

export const isSafariUserAgent = (): boolean => {
    if (typeof getUserAgentDetails !== 'function') {
        return true;
    }
    const userAgentInfo = typeof window !== 'undefined' ? getUserAgentDetails(window.navigator.userAgent) : undefined;
    return userAgentInfo?.browser === 'safari';
};
